import { render, staticRenderFns } from "./CompanyCompareModal.vue?vue&type=template&id=0f720e62"
import script from "./CompanyCompareModal.vue?vue&type=script&lang=ts"
export * from "./CompanyCompareModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports